export default [
  // Pedidos deshabilitado temporalmente (en mantenimiento)
  // {
  //   title: 'Pedidos',
  //   route: 'orders',
  //   icon: 'BookOpenIcon',
  // },
  {
    title: 'Productos',
    route: 'categoriesList',
    icon: 'PackageIcon',
  },
  {
    title: 'Usuarios',
    route: 'users',
    icon: 'UsersIcon',
  },
  {
    title: 'Mi Empresa',
    route: 'currentClient',
    icon: 'BriefcaseIcon',
  },
  {
    title: 'Obras',
    route: 'projects',
    icon: 'HomeIcon',
  },
  {
    title: 'Equipos',
    route: 'assets',
    icon: 'CpuIcon',
  },
  {
    title: 'Incidencias',
    route: 'incidences',
    icon: 'AlertTriangleIcon',
  },
  {
    title: 'Mantenimiento',
    route: 'maintenances',
    icon: 'ToolIcon',
  },
]
